import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../interfaces/api';
import { USER } from '../../interfaces/auth.interface';
import { BeatLoader } from '../Spinners/Spinner';
import AmountForm from './AmountForm';
import PaymentMethods from './PaymentMethod';

interface Props extends PropsFromRedux {}

export interface FormInput {
  Amount: number;
  OnlinePaymentType: 'Paystack' | 'Flutterwave' | 'Cellulant' | 'Sterling' | 'Korapay' | '';
  CardCode : number
}



const FundWallet: React.FC<Props> = ({
  hideModal,
  verificationState,
  user,
  resetApi,
  getEquivalent,
  getEquivalentState
}) => {
  const userObj: USER = user?.response?.Object;
  const [formstep, setFormStep] = React.useState<'amount' | 'payment_method' >(
    'amount'
  );

  React.useEffect(
    () => () => {
      resetApi(API_KEYS.GENERATE_CHECKOUT_URL);
    },
    [resetApi]
  );

  const [formValues, setFormValues] = React.useState<FormInput>({
    Amount: 0,
    OnlinePaymentType: '',
    CardCode : 0
  });

  const history = useHistory();
  const location = useLocation();

  const closeModal = () => {
    hideModal();
    if (location.pathname.includes('wallet')) {
      history.push('/wallet');
    }
  };

  if (verificationState.loading) {
    return (
      <div className="w-full px-4 bg-white rounded-xl lg:px-14 py-10 relative">
        <button type="button" onClick={closeModal} aria-label="Close">
          <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
        </button>

        <div className="w-full text-center">
          <h4 className="text-3xl mb-5 font-bold">Fund Wallet</h4>
        </div>

        <p className="font-medium my-5">
          Processing your payment... <BeatLoader />
        </p>
      </div>
    );
  }

  return (
    <div className="w-full px-4 bg-white rounded-xl lg:px-14 py-10 relative">
      <button type="button" onClick={closeModal} aria-label="Close">
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>

      <div className="w-full text-center">
        <h4 className="text-3xl mb-5 font-bold">Fund Wallet</h4>
      </div>
      {formstep === 'amount' && (
        <AmountForm
          user={userObj}
          formValues={formValues}
          setFormValues={setFormValues}
          setFormStep={setFormStep}
        />
      )}
      {formstep === 'payment_method' && (
        <PaymentMethods
          formValues={formValues}
          setFormValues={setFormValues}
          setFormStep={setFormStep}
        />
      )}
    </div>
  );
};

export default FundWallet;
